import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "ErrorMessage__StyledUIFlex",
  componentId: "sc-1iiecan-0"
})([".hs-private.hs-private.hs-private &{height:100%;}"]);
export default function ErrorMessage({
  title,
  message,
  type,
  illustration,
  className
}) {
  return /*#__PURE__*/_jsx(StyledUIFlex, {
    direction: "row",
    align: "center",
    className: className,
    children: /*#__PURE__*/_jsx(UIErrorMessage, {
      type: type,
      title: title,
      illustration: illustration,
      children: message ? /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: message
        })
      }) : null
    })
  });
}